export default "/app/global-wrapper-client/static/1ebbcf46fd55bf3c259f195442bc04b3.ttf";